// src/components/FiltrosBar.js
import React, { useState } from 'react';

function FiltrosBar({ filtros, onFiltrar }) {
  const [search, setSearch] = useState(filtros.search || '');
  const [tecnico, setTecnico] = useState(filtros.tecnico_nome || '');
  const [tipo, setTipo] = useState(filtros.tipo_servico || '');

  const handleFiltrar = () => {
    onFiltrar({
      ...filtros, // Mantém mes_ano e outros filtros
      search,
      tecnico_nome: tecnico,
      tipo_servico: tipo
    });
  };

  const handleLimpar = () => {
    setSearch('');
    setTecnico('');
    setTipo('');
    // Recarregar página para voltar ao estado inicial
    window.location.reload();
  };

  return (
    <div className="filtros-bar">
      <div className="filtros-content">
        <div className="filtro-search">
          <input
            type="text"
            placeholder="🔍 Buscar oportunidade, cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleFiltrar()}
            className="input-search"
          />
        </div>

        <select
          value={tecnico}
          onChange={(e) => setTecnico(e.target.value)}
          className="select-filter"
        >
          <option value="">Todos os técnicos</option>
          <option value="Salatiel">Salatiel</option>
          <option value="Técnico 2">Técnico 2</option>
        </select>

        <select
          value={tipo}
          onChange={(e) => setTipo(e.target.value)}
          className="select-filter"
        >
          <option value="">Todos os tipos</option>
          <option value="CFTV">CFTV</option>
          <option value="Rede">Rede</option>
          <option value="Wi-Fi">Wi-Fi</option>
          <option value="Interfone">Interfone IP</option>
          <option value="Alarme">Alarme</option>
          <option value="Mix">Mix</option>
        </select>

        <button onClick={handleFiltrar} className="btn-filtrar">
          Filtrar
        </button>

        <button onClick={handleLimpar} className="btn-limpar">
          Limpar
        </button>
      </div>
    </div>
  );
}

export default FiltrosBar;
